import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Inquiry } from "@lbsdk/*";
import { Subscription } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { InquiryService } from "@app/main/content/inquiry/detail/inquiry.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { environment } from "@env/environment";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import {
  MatDialog,
  MatDialogRef,
  MatPaginator,
  PageEvent,
} from "@angular/material";
import * as _ from "lodash";
import { Router } from "@angular/router";
import { ConfirmationDialogComponent } from "../../confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "fuse-app-detail",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class DetailComponent implements OnInit, OnDestroy {
  inquiry: any;
  onInquiryChanged: Subscription;
  pageType: string;
  inquiryForm: FormGroup;
  s3BucketUrl = environment.s3BucketUrl;
  messages: any[] = [];
  reply: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageIndex: number = 0;
  pageSize: number = 5;
  lowValue: number = 0;
  highValue: number = 5;
  pageEvent: any;

  confirmDialogRef: MatDialogRef<ConfirmationDialogComponent>;

  constructor(
    private inquiryService: InquiryService,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private fuseSplashScreenService: FuseSplashScreenService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    // Subscribe to update product on changes
    this.onInquiryChanged = this.inquiryService.onInquiryChanged.subscribe(
      (inquiry) => {
        if (inquiry) {
          this.inquiry = inquiry;
          if (this.inquiry.playerPrize && this.inquiry.playerPrize.prize.type === "solo") {
            Object.keys(inquiry.playerPrize.prize)
              .filter((el) => el.includes("image"))
              .forEach((img) => {
                if (this.inquiry.playerPrize.prize[img].image !== "")
                  this.inquiry.playerPrize.prize.image1.image =
                    this.inquiry.playerPrize.prize[img].image;
              });
          }
          this.pageType = "edit";
        } else {
          this.pageType = "new";
          this.inquiry = new Inquiry();
        }

        this.inquiryForm = this.createInquiryForm();

        this.splitInquiryMessages();
      }
    );
  }

  ngOnDestroy() {
    this.onInquiryChanged.unsubscribe();
  }

  createInquiryForm() {
    return this.formBuilder.group({
      subject: [{ value: this.inquiry.subject, disabled: true }],
      message: ["", [Validators.required]],
    });
  }

  splitInquiryMessages() {
    this.messages = [];
    let inquiryMessages = JSON.parse(this.inquiry.message);
    inquiryMessages.forEach((el) => {
      let key = Object.keys(el)[0];
      this.messages.push({ userType: key, message: el[key] });
    });
    this.messages = _.cloneDeep(this.messages.reverse());
  }

  getPaginatorData(event) {
    if (event.pageIndex === this.pageIndex + 1) {
      this.lowValue = this.lowValue + this.pageSize;
      this.highValue = this.highValue + this.pageSize;
    } else if (event.pageIndex === this.pageIndex - 1) {
      this.lowValue = this.lowValue - this.pageSize;
      this.highValue = this.highValue - this.pageSize;
    }
    this.pageIndex = event.pageIndex;
  }

  sendInquiry = async () => {
    let formData = this.inquiryForm.getRawValue();
    let messages: any = _.cloneDeep(
      this.messages.map((el) => ({ [el.userType]: el.message })).reverse()
    );
    messages.push({ admin: formData.message });
    this.inquiry.message = JSON.stringify(messages);
    this.fuseSplashScreenService.show();
    try {
      let response = await this.inquiryService
        .patchInquiry(this.inquiry)
        .toPromise();
      if (!response) {
        this.fuseSplashScreenService.hide();
        return;
      }
      this.splitInquiryMessages();
      this.inquiryForm.get("message").reset();
      this.reply = false;
      this.snackBar.open("Reply sent successfully!", "OK", {
        verticalPosition: "top",
        duration: 2000,
      });
      this.fuseSplashScreenService.hide();
    } catch (error) {
      console.log("error on  inquiry updated...", error);
      this.fuseSplashScreenService.hide();
    }
  };

  deleteInquiry = () => {
    this.confirmDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want delete?`,
      },
    });
    this.confirmDialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.fuseSplashScreenService.show();
        try {
          let response: any = await this.inquiryService
            .deleteInquiry(this.inquiry.id)
            .toPromise();

          if (!response) {
            this.fuseSplashScreenService.hide();
            return;
          }
          this.router.navigate(["/inquires"]);
          this.fuseSplashScreenService.hide();
        } catch (error) {
          this.fuseSplashScreenService.hide();
          console.log("error");
        }
      }
    });
  };

  onErrorImage() {
    this.inquiry.player.profileImage =
      "assets/images/ecommerce/product-image-placeholder.png";
  }
}
